<template>
	<Dashboard></Dashboard>
</template>

<script>
import Dashboard from '@/components/dashboard';

export default {
	components: {
		Dashboard,
	},
	data: function () {
		return {};
	},
	watch: {},
	methods: {},
};
</script>

<style lang="scss">
</style>
